import {Component, Inject, OnInit} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';

@AcDialog({
  width: 1500,
  height: 400,
  title: 'TEST ROUTE DETAILS'
})
@Component({
  selector: 'test-route-details-dialog',
  templateUrl: './test-route-details-dialog.component.html',
  styleUrls: ['./test-route-details-dialog.component.scss']
})
export class TestRouteDetailsDialogComponent implements OnInit {

  dialogData;
  manipulationBeforeRouting: any = [];
  manipulationDuringRouting: any = [];
  description: string;

  constructor(@Inject(DIALOG_CONFIG) public dialogConfig) {
    this.dialogData = dialogConfig.dialogData;
    this.manipulationBeforeRouting = this.dialogData.manipulations.filter(manipulation => manipulation.manipulationType === 'Before route');
    this.manipulationDuringRouting = this.dialogData.manipulations.filter(manipulation => manipulation.manipulationType === 'During route');
    this.description = this.dialogData.description;
  }

  ngOnInit(): void {
  }

}
